'use strict';

module.exports = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-pagination-2/compiled/themes/bootstrap3.js
// module id = STbB
// module chunks = 0